import script from "./EmployeeContractForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmployeeContractForm.vue?vue&type=script&lang=ts&setup=true"

import "./EmployeeContractForm.vue?vue&type=style&index=0&id=512cebb2&lang=scss"

const __exports__ = script;

export default __exports__